/**
 * @voltxampere/ui — USB Type-A connector (Sprint 45-6, schema-only)
 *
 * Schema-only passthrough — engine'de davranış yok. 4-pin USB-A:
 * VBUS (+5V), D-, D+, GND. Drag-drop + visual + pin mapping
 * Inspector card'da görünür.
 *
 * Reference: Generic USB Type-A connector (USB 2.0 standart).
 * VBUS 5 V @ 500 mA / 900 mA (USB 3.0). USB-PD Sprint 47+'da.
 *
 * Engine zero-diff invariant honored — canonical `wire-node`
 * engine type via schemaType (passthrough).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { node } from "../node.js";
export const connectorUsbA = {
    id: "usb-a",
    nameTr: "USB-A (Type-A 4-pin, schema-only)",
    nameEn: "USB-A (Type-A 4-pin, schema-only)",
    shortcut: "N",
    category: "connector",
    viewBox: node.viewBox,
    terminals: node.terminals,
    defaultLabel: "J",
    defaultValue: "USB-A",
    schemaType: "wire-node",
    defaultParams: {},
    renderSVG: () => node.renderSVG(),
};
//# sourceMappingURL=connector-usb-a.js.map